'use client';

import { useEffect } from 'react';

export default function DbSetup() {
  useEffect(() => {
    // Silently verify DB schema is ready on app load
    fetch('/api/setup-db')?.then((res) => res?.json())?.then((data) => {
        if (process.env.NODE_ENV === 'development') {
          console.log('[DbSetup]', data?.message || data?.status);
        }
      })?.catch(() => {
        // Silent fail — non-critical check
      });
  }, []);

  return null;
}
